// JavaScript source code
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import './FormSubmit.css';
import header from './assets/images/header.jpg';

function FormSubmit() {
    const location = useLocation();
    const formAction = location.state?.formAction || 'submitted';

    return (
        <div className="form-container">
            <div className="header-container">
                <img src={header} alt="Header" className="header-image" />
            </div>
            <div className="block-message-container">
                <div className="block-message-box">
                    <h2>Form Submission</h2>
                    <p>Form {formAction}, you will receive email notification about the result in a few working days. Thank you for choosing us.</p>
                    <div className="block-message-icon">✉️</div>
                </div>
            </div>
        </div>
    );
}
export default FormSubmit;